import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import { useTheme } from '@mui/material/styles';

interface DeviceStatusProps {
  deviceName: string;
  isConnectionError: boolean;
}

const DeviceStatus: React.FC<DeviceStatusProps> = ({ deviceName, isConnectionError }) => {
  const theme = useTheme();
  const color = isConnectionError ? theme.palette.error.main : theme.palette.primary.main;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Fade in={isConnectionError} timeout={500} unmountOnExit>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <CircularProgress size={24} style={{ color, marginRight: theme.spacing(1) }} />
        </Box>
      </Fade>
      <Typography style={{ 
        color, 
        transition: theme.transitions.create('color', {
          duration: theme.transitions.duration.standard,
        }) 
      }}>
        {deviceName}
      </Typography>
    </Box>
  );
};

export default DeviceStatus;
